export const setPayerData = (payload: {}) => ({
  type: 'SET_PAYER_DETAILS',
  payload,
});

export const setPaymentData = (payload: {}) => ({
  type: 'SET_PAYMENT_DETAILS',
  payload,
});
